import { GoodsDetailActions as GoodsDetail } from "./GoodsDetail";
import { combineReducers, createStore, Store } from "lib/store/v3";
import { createStoreLogger } from "lib/store/v3/createStoreLogger";

const reducer = combineReducers({ GoodsDetail }, createStoreLogger("GoodsDetail"));

export type GoodsDetailStore = Store<typeof reducer>;

export const { useSelector: useGoodsDetailSelector, ...GoodsDetailStore } = createStore(reducer);
